import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "catch-doll-rule-popup" }
const _hoisted_2 = { class: "popup-main" }
const _hoisted_3 = { class: "popup-header flex" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "popup-content" }
const _hoisted_6 = {
  key: 0,
  class: "record-wrap"
}
const _hoisted_7 = { class: "record-header flex" }
const _hoisted_8 = { class: "record-header-item date" }
const _hoisted_9 = { class: "record-header-item" }
const _hoisted_10 = { class: "record-header-item" }
const _hoisted_11 = { class: "scroll-view" }
const _hoisted_12 = { class: "record-item-detail flex" }
const _hoisted_13 = { class: "record-value date" }
const _hoisted_14 = { class: "record-value flex justify-center" }
const _hoisted_15 = { class: "record-value" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 1,
  class: "rule-text-wrap"
}
const _hoisted_18 = { class: "rule-text align-center" }
const _hoisted_19 = { class: "rule-text align-center" }

import { ref, watch, onMounted } from 'vue';
import { queryCatchDollRecord } from '@/api';


export default {
  __name: 'Rule',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const typeList = ref(['rules', 'records']);
const activeType = ref('');
const loading = ref(false);
const finished = ref(false);
const refreshing = ref(false);
const dataList = ref([]);
const current = ref(1);
const pageSize = ref(10);

watch(activeType, (newValue, oldValue) => {
  if (newValue == 'records') {
    reloadData()
  }
})

onMounted(() => {
  activeType.value = typeList.value[0];
})

const fetchList = () => {
  queryCatchDollRecord({
    pageSize: pageSize.value,
    current: current.value,
  }).then(res => {
    dataList.value = dataList.value.concat(res.data || []);
    if (res.total <= res.page * pageSize.value) {
      finished.value = true;
    } else {
      current.value = res.page + 1;
    }
    loading.value = false;
  });
}

const loadData = () => {
  if (refreshing.value) {
    dataList.value = [];
    current.value = 1;
    refreshing.value = false;
  }
  fetchList();
}

const refreshData = () => {
  // 清空列表数据
  finished.value = false;
        
  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true;
  loadData();
}

const reloadData = () => {
  finished.value = false;
  refreshing.value = true;
  loadData();
}


return (_ctx, _cache) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_list = _resolveComponent("van-list")
  const _component_van_empty = _resolveComponent("van-empty")
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: true,
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item,
                class: _normalizeClass(["type-item", { active: activeType.value === item }]),
                onClick: $event => (activeType.value = item)
              }, _toDisplayString(_ctx.$t(`common.${item}`)), 11, _hoisted_4))
            }), 128)),
            _withDirectives(_createVNode(_component_van_icon, {
              class: "close-icon",
              name: "close",
              onClick: _cache[0] || (_cache[0] = $event => (emit('onClose')))
            }, null, 512), [
              [_directive_audio, void 0, "close"]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (activeType.value === 'records')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('label.drawDate')), 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('label.prize')), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('label.amount')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_van_pull_refresh, {
                      modelValue: refreshing.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((refreshing).value = $event)),
                      onRefresh: refreshData
                    }, {
                      default: _withCtx(() => [
                        (dataList.value.length > 0)
                          ? (_openBlock(), _createBlock(_component_van_list, {
                              key: 0,
                              loading: loading.value,
                              "onUpdate:loading": _cache[1] || (_cache[1] = $event => ((loading).value = $event)),
                              class: "record-list",
                              finished: finished.value,
                              "finished-text": _ctx.$t('common.noMore'),
                              onLoad: loadData
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "record-item",
                                    key: item.id
                                  }, [
                                    _createElementVNode("div", _hoisted_12, [
                                      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$moment(item.time * 1000).format('YYYY-MM-DD HH:mm:ss')), 1),
                                      _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("div", null, _toDisplayString(_ctx.$t(`catchDoll.doll.${item.remark}`)), 1),
                                        _createVNode(_component_van_image, {
                                          class: "doll-img",
                                          fit: "contain",
                                          src: require(`@/assets/img/catch-doll/doll/${item.remark}.png`)
                                        }, null, 8, ["src"])
                                      ]),
                                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$filter.outputAmount(item.bonus)) + "PHP", 1)
                                    ]),
                                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "divider-line" }, null, -1))
                                  ]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["loading", "finished", "finished-text"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createVNode(_component_van_empty, {
                                description: _ctx.$t('common.noData')
                              }, null, 8, ["description"])
                            ]))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('catchDoll.rule.content1')), 1),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('catchDoll.rule.content2')), 1)
                ]))
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

}